var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconViewta = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.2611 6C15.4898 6.00726 14.6923 6.33406 13.9929 7.10385C11.2149 10.1903 14.81 15.1213 18.1044 12.703L21.0719 16L22.0001 14.9688L19.0325 11.6717C20.6601 8.92665 18.575 5.99274 16.2611 6ZM16.2415 7.496C17.2677 7.45969 18.2678 8.33841 18.2678 9.67465C18.2678 10.2525 18.0612 10.8066 17.6934 11.2152C17.3257 11.6238 16.8269 11.8533 16.3068 11.8533C14.5616 11.8533 13.6922 9.50762 14.9211 8.13507C15.3067 7.70661 15.7774 7.496 16.2415 7.496Z",
  fill: "#7F7F7F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 5C8 4.44772 8.44772 4 9 4H11C11.5523 4 12 4.44772 12 5V19H8V5Z",
  fill: "#7F7F7F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 12C3 11.4477 3.44772 11 4 11H6C6.55228 11 7 11.4477 7 12V19H3V12Z",
  fill: "#7F7F7F"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 12.5C13 12.5 14.5 14 16 14C15.7305 14 16.1797 14 16 14C16.5 14 17 13.9375 17 13.9375V19H13V12.5Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconViewta);
export { ForwardRef as ReactComponent };